import React, {Component} from 'react';
import './PortalHeader.css';
import PortalBranding from "./PortalBranding";
import SessionHelper from "../../System/SessionHelper";
import {Link, Redirect} from 'react-router-dom';
import PropTypes from 'prop-types';

export default class PortalHeader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sessionInfoUpdated: false,

            loaderVisible: false,
            loaderProgress: 0
        };

        this.handleSessionChange = this.handleSessionChange.bind(this);
    }

    handleSessionChange() {
        this.setState({
            sessionInfoUpdated: true
        });
    }

    componentDidMount() {
        SessionHelper.onChange(this.handleSessionChange);

        this.interval = setInterval(this.handleLoaderTick.bind(this), 200);
    }

    componentWillUnmount() {
        SessionHelper.removeOnChangeListener(this.handleSessionChange);

        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }

    handleLoaderTick() {
        let wasVisible = !!this.state.loaderVisible;
        let makeVisible = false;
        let nextProgress = this.state.loaderProgress;

        if (this.props.isLoading || wasVisible) {
            // Already visible or prop changed to make visible
            makeVisible = true;

            if (!wasVisible) {
                // Start at 10% always
                nextProgress = 10;
            }
        }

        if (nextProgress >= 90) {
            // Stand still
        } else if (nextProgress >= 80) {
            // Tiny ticks
            nextProgress += .1;
        } else if (nextProgress >= 70) {
            // Small ticks
            nextProgress += .5;
        } else {
            // Big ticks
            nextProgress += 5;
        }

        if (makeVisible && !this.props.isLoading) {
            if (nextProgress < 100) {
                // Final frame
                nextProgress = 100;
            } else {
                // Final frame done
                makeVisible = false;
            }
        }

        if (!makeVisible) {
            nextProgress = 0;
        }

        if (this.state.loaderVisible !== makeVisible || this.state.loaderProgress !== nextProgress) {
            this.setState({
                loaderVisible: makeVisible,
                loaderProgress: nextProgress
            });
        }
    }

    render() {
        if (this.state.sessionInfoUpdated && !SessionHelper.isLoggedIn) {
            return <Redirect to={"/"}/>;
        }

        return (
            <div>
                {this.state.loaderVisible &&
                    <div className={"PortalHeaderLoader"} style={{ width: `${this.state.loaderProgress}%` }}/>
                }
                <div className={"PortalHeader"}>
                    <a className={"PortalHeader__branding"}>
                        <PortalBranding/>
                    </a>
                    <div className={"PortalHeader__burger"} onClick={this.props.onBurgerClick}>
                        <i className={"mdi mdi-menu"}/>
                    </div>
                    <div className={"PortalHeader__text"}>
                        <h1 className={"PortalHeader__text-title"}>{this.props.title}</h1>
                        <span className={"PortalHeader__text-sub"}>{this.props.subText}</span>
                    </div>
                    <div className={"PortalHeader__fill"}/>

                    {SessionHelper.isLoggedIn &&
                        <Link to={"/account"} className={"PortalHeader__user"}>
                            <img className={"PortalHeader__user-avatar"} alt={SessionHelper.userName}
                                 src={SessionHelper.userAvatarUrl}/>
                            <p className={"PortalHeader__user-txt"}>Hallo, {SessionHelper.userName}</p>
                            <i className={"PortalHeader__user-xpandicon mdi mdi-chevron-right"}/>
                        </Link>
                    }
                </div>
            </div>
        );
    }
}

PortalHeader.propTypes = {
    title: PropTypes.string,
    subText: PropTypes.string,
    isLoading: PropTypes.bool,
    onBurgerClick: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/Portal/Parts/PortalHeader.js